import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSettings, type UiLang } from '../lib/settings';
import de from './locales/de';
import en from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';
import pt from './locales/pt';

export const resources = {
  fr: { translation: fr },
  en: { translation: en },
  es: { translation: es },
  de: { translation: de },
  it: { translation: it },
  pt: { translation: pt },
} as const;

export function initI18n(): typeof i18next {
  void i18next.use(initReactI18next).init({
    resources,
    lng: getSettings().uiLang,
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  document.documentElement.lang = getSettings().uiLang;
  return i18next;
}

export async function setUiLanguage(lang: UiLang): Promise<void> {
  await i18next.changeLanguage(lang);
  document.documentElement.lang = lang;
}
